/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamReferenceShowQueryResponse,
  GetApiV1ExamReferenceShow401,
  GetApiV1ExamReferenceShow500,
} from "../../types/examEvaluationController/GetApiV1ExamExamReferenceShow.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamReferenceShow } from "../../clients/examEvaluationController/getApiV1ExamExamReferenceShow.ts";

export const getApiV1ExamExamReferenceShowQueryKey = () =>
  [{ url: "/api/v1/exam/exam-reference-show" }] as const;

export type GetApiV1ExamExamReferenceShowQueryKey = ReturnType<
  typeof getApiV1ExamExamReferenceShowQueryKey
>;

export function getApiV1ExamExamReferenceShowQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamReferenceShowQueryKey();
  return queryOptions<
    GetApiV1ExamReferenceShowQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamReferenceShow401 | GetApiV1ExamReferenceShow500
    >,
    GetApiV1ExamReferenceShowQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamReferenceShow({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções de exibição de gabarito disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar opções de exibição de gabarito para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-reference-show}
 */
export function useGetApiV1ExamExamReferenceShow<
  TData = GetApiV1ExamReferenceShowQueryResponse,
  TQueryData = GetApiV1ExamReferenceShowQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamReferenceShowQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamReferenceShowQueryResponse,
        ResponseErrorConfig<
          GetApiV1ExamReferenceShow401 | GetApiV1ExamReferenceShow500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamExamReferenceShowQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamExamReferenceShowQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1ExamReferenceShow401 | GetApiV1ExamReferenceShow500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
